import type { ScreenerColumn, ScreenerSubField } from "epsm-api-types/models";

export const getColumnTitle = (
	column: ScreenerColumn | ScreenerSubField,
	isSubfield = false,
) => {
	if (isSubfield) {
		return column.titleShort || column.title;
	}
	return (column as any).titleAbbreviation || column.titleShort || column.title;
};
